//Form Décla
document.addEventListener('livewire:load', function () {
    Livewire.emit('initmask');
});
document.addEventListener('getmask', function (event) {
    selector = document.getElementById("contractNumberField");
    if (selector !== null){
        nextbutton = document.getElementById("nextstep");
        nextbutton.setAttribute('disabled', 'disabled');
        if (selector.inputmask) {
            selector.inputmask.remove();
        }
        im = new Inputmask(event.detail.mask, {
            onBeforeMask: function (value, opts) {
                if (null === value) {
                    value = '*'
                }
                return value;
            },
            oncomplete: function(){
                nextbutton.removeAttribute('disabled');
            }
        });
        if(!im.isValid(selector.value)){
            selector.value = '';
        }else{
            nextbutton.removeAttribute('disabled');
        }
        im.mask(selector);
    }
});

document.addEventListener('reMask', function(event){
    setTimeout( function() { Livewire.emit('initmask');}, 1000);
});

// On clicking submit do following
$("#nextstep").click(function () {
    var atLeastOneChecked = false;
    $("input[type='radio'][name='civility']").each(function () {
        // If radio button not checked display alert message
        if ($(this).is(':checked')) {
            atLeastOneChecked = true;
        }
    });
    if (!atLeastOneChecked) {
        $("#msg").html("<span class='text-danger'>Veuillez sélectionner ce champ</span>");
    }
});
